// True when the app is loaded from the admin subdomain (e.g. admin.sankyomt.ph)
// rather than the main site — lets the admin routes mount at the root instead
// of under /admin, without needing two separate builds or deployments.
export const IS_ADMIN_HOST = typeof window !== 'undefined' && window.location.hostname.startsWith('admin.');

// '' on the admin subdomain (admin routes live at /, /hero, /login, ...)
// '/admin' on the main domain (admin routes live at /admin, /admin/hero, /admin/login, ...)
export const ADMIN_BASE = IS_ADMIN_HOST ? '' : '/admin';

// Absolute link back to the public marketing site — needed from the admin
// subdomain, where a bare "/" would just point at the admin dashboard instead.
export const PUBLIC_SITE_URL = IS_ADMIN_HOST
  ? `${window.location.protocol}//${window.location.hostname.replace(/^admin\./, '')}/`
  : '/';
